import React, { useState, useEffect, useRef } from "react";

import { Dialog } from "primereact/dialog";

import pdfMake from "pdfmake/build/pdfmake";
import { getLabel } from "../../../Services/Language/LanguageService";
import { ReporteLang } from "./ReporteLang";
import { numeroALetras, numeroALetrasUnidades } from '../../../Services/funciones'

export const ConvenioDoc = ({
  showReporte,
  setShowReporte,
  selected,
  setSelected,
  lenguaje,
}) => {
  const [loading, setLoading] = useState(false);
  const [pdf, setPdf] = useState([]);
  const toast = useRef();

  const getInfo = async () => {
    setLoading(true);
    if (selected) {
      let Plural = "libras"
      let Singular = 'libra'

      let Plural1 = "dólares estadounidenses"
      let Singular1 = 'dólar estadounidense'

      let centPlural = 'centavos'
      let centSingular = 'centavo'

      let Plural2 = " "
      let Singular2 = ' '

      const CantMinimaLetras = numeroALetrasUnidades(selected?.MinimoCompra, {
        plural: Plural,
        singular: Singular,
      })

      const CreditLimitLetras = numeroALetras(selected?.CreditLimit, {
        plural: Plural1,
        singular: Singular1,
      }).toLowerCase();

      const TerminoLetras = numeroALetrasUnidades(selected?.TermValue, {
        plural: Plural2,
        singular: Singular2,
      })

      const duracionLetras = numeroALetrasUnidades(selected?.Duracion, {
        plural: Plural2,
        singular: Singular2,
      })

      const fecha = new Date(selected?.DateConvenio);

      const fechaFormateada = fecha.toLocaleDateString('es-ES', {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
      });

      const cargoExtraLetras = numeroALetras(selected?.CargoExtra, {
        plural: Plural1,
        singular: Singular1,
        centPlural: centPlural,
        centSingular: centSingular
      }).toLowerCase();


      

      GenerarReporte(CantMinimaLetras, CreditLimitLetras, TerminoLetras, duracionLetras, fechaFormateada, cargoExtraLetras);
    } else {
    }
    setLoading(false);
  };

  const GenerarReporte = async (CantMinimaLetras, CreditLimitLetras, TerminoLetras, duracionLetras, fechaFormateada, cargoExtraLetras) => {
    let reporte = [];

    const docDefinition = {
      // pageSize: "LETTER",
      pageSize: { width: 612, height: 936 }, 
      pageOrientation: "portrait",
      pageMargins: [40, 85, 40, 60],


      // HEADER
      header: function (currentPage, pageCount, pageSize) {
        return [
          {
            widths: ["*", "25%"],
            columns: [
              [{}, {}],
              [
                {
                  text: `${getLabel(ReporteLang, "convenio", lenguaje)}`,
                  style: "tituloHeader",
                  margin: [0, 30, 40, 0],
                },
                {
                  text: `${selected?.Correlativo || ""}`,
                  style: "titulo",
                  margin: [0, 0, 40, 0],
                },
              ],
            ],
          },
        ];
      },

      content: [
        {
          columns: [
            //-------------PRIMERA COLUMNA
            {
              width: "*",
              lineHeight: 1.15,
              stack: [

                //--------------------------------------------------------------HOJA 1----------------------------------------------------------------
                {
                  text: [
                    {
                      text: `${getLabel(ReporteLang, "ElPresente", lenguaje)}`,
                      style: "textGeneral",
                    },
                    {
                      text: `Pride Performance Fabrics, S. A. de C. V., `,
                      style: "textGeneralBold",
                    },
                    {
                      text: `${getLabel(ReporteLang, "enDelante", lenguaje)}`,
                      style: "textGeneral",
                    },
                    {
                      text: `${selected?.CustomerName || ""}`,
                      style: "textGeneralBold",
                    },
                    {
                      text: `${getLabel( ReporteLang, "enDelante1", lenguaje)}\n\n`,
                      style: "textGeneral",
                    },
                  ],
                },

                {
                  text: `${getLabel(ReporteLang, "ElObjetivo", lenguaje)}\n\n`,
                  style: "textGeneral",
                },

                {
                  text: `1. ${getLabel( ReporteLang, "Regulaciones", lenguaje)}\n`,
                  style: "textGeneralBold",
                  margin: [0, 3, 0, 0],
                },
                {
                  text: `${getLabel( ReporteLang, "RegulacionesText", lenguaje)}\n\n`,
                  style: "textGeneral",
                },

                {
                  text: `2. ${getLabel( ReporteLang, "Especificaciones", lenguaje)}\n`,
                  style: "textGeneralBold",
                  
                },
                {
                  text: `${getLabel( ReporteLang, "EspecificacionesText", lenguaje)}\n\n`,
                  style: "textGeneral",
                },
                {
                  text: `3. ${getLabel(ReporteLang, "Precios", lenguaje)}\n`,
                  style: "textGeneralBold",
                  margin: [0, 3, 0, 0],
                },
                {
                  text: `${getLabel(ReporteLang, "PreciosText", lenguaje)}\n`,
                  style: "textGeneral",
                },
                {
                  table: {
                    widths: ["4%", "*"],
                    body: [
                      [
                        {
                          text: "a)",
                          style: "textGeneral",
                        },
                        {
                          text: `${getLabel( ReporteLang, "PreciosA_1", lenguaje)}\n`,
                          style: "textGeneral",
                          margin: [-5, 0, 0, 8],
                        },
                      ],
                      [
                        {
                          text: "b)",
                          style: "textGeneral",
                        },
                        {
                          text: `${getLabel( ReporteLang, "PreciosB_1", lenguaje)}\n`,
                          style: "textGeneral",
                          margin: [-5, 0, 0, 8],
                        },
                      ],
                    ],
                  },
                  layout: "noBorders",
                  margin: [0, 0, 0, 8],
                },

                {
                  text: `4. ${getLabel(ReporteLang, "Desc", lenguaje)}\n`,
                  style: "textGeneralBold",
                },
                {
                  table: {
                    widths: ["4%", "*"],
                    body: [
                      [
                        {
                          text: "a)",
                          style: "textGeneral",
                        },
                        {
                          text: `${getLabel( ReporteLang, "DescA", lenguaje)}`,
                          style: "textGeneral",
                          margin: [-5, 0, 0, 0],
                        },
                      ],
                      [
                        {
                          text: "b)",
                          style: "textGeneral",
                        },
                        {
                          text: `${getLabel( ReporteLang, "DescB", lenguaje)}`,
                          style: "textGeneral",
                          margin: [-5, 0, 0, 0],
                        },
                      ],
                      [
                        {
                          text: "c)",
                          style: "textGeneral",
                        },
                        {
                          text: [
                            {
                              text: `${getLabel( ReporteLang, "DescC", lenguaje)}`,
                            },
                            {
                              text: `${(CantMinimaLetras || '')}` + ` (${selected?.MinimoCompra?.toLocaleString('en-US')} lbs)`,
                            },
                            {
                              text: `${getLabel( ReporteLang, "mensuales", lenguaje)}`,
                            },
                          ],
                          style: "textGeneral",
                          margin: [-7, 0, 0, 0],
                        },
                      ],
                    ],
                  },
                  layout: "noBorders",
                  margin: [0, 0, 0, 8],
                },

                {
                  text: `5. ${getLabel(ReporteLang, "entrega", lenguaje)}\n`,
                  style: "textGeneralBold",
                  margin: [0, 3, 0, 0],
                },
                {
                  table: {
                    widths: ["4%", "*"],
                    body: [
                      [
                        {
                          text: "a)",
                          style: "textGeneral",
                        },
                        {
                          text: `${getLabel( ReporteLang, "entregaA", lenguaje)}`,
                          style: "textGeneral",
                          margin: [-5, 0, 0, 0],
                        },
                      ],
                      [
                        {
                          text: "b)",
                          style: "textGeneral",
                        },
                        {
                          text: `${getLabel( ReporteLang, "entregaB", lenguaje)}\n`,
                          style: "textGeneral",
                          margin: [-5, 0, 0, 0],
                        },
                      ],
                    ],
                  },
                  layout: "noBorders",
                  margin: [0, 0, 0, 8],
                },

                //--------------------------------------------------------------HOJA 2----------------------------------------------------------------
                {
                  text: `${getLabel(ReporteLang, "resolucionText_1", lenguaje)}\n\n`,
                  style: "textGeneral",
                },
                {
                  text: `10. ${getLabel(ReporteLang, "fuerza", lenguaje)}\n`,
                  style: "textGeneralBold",
                  margin: [0, 5, 0, 0],
                },
                {
                  text: `${getLabel(ReporteLang, "fuerzaText", lenguaje)}\n\n`,
                  style: "textGeneral",
                  margin: [0, 0, 0, 0],
                },

                {
                  text: `11. ${getLabel(ReporteLang, "materia", lenguaje)}\n`,
                  style: "textGeneralBold",
                  margin: [0, 5, 0, 0],
                },
                {
                  text: `${getLabel(ReporteLang, "materiaText", lenguaje)}\n`,
                  style: "textGeneral",
                  margin: [0, 0, 0, 0],
                },
                {
                  table: {
                    widths: ["4%", "*"],
                    body: [
                      [
                        {
                          text: "a)",
                          style: "textGeneral",
                        },
                        {
                          text: `${getLabel( ReporteLang, "materiaA", lenguaje)}\n`,
                          style: "textGeneral",
                          margin: [-5, 0, 0, 2],
                        },
                      ],
                      [
                        {
                          text: "b)",
                          style: "textGeneral",
                        },
                        {
                          text: `${getLabel( ReporteLang, "materiaB", lenguaje)}` + `${cargoExtraLetras}` + ` (USD ${selected?.CargoExtra}) ` + `${getLabel( ReporteLang, "materiaB_1", lenguaje)}`,
                          style: "textGeneral",
                          margin: [-5, 0, 0, 2],
                        },
                      ],
                      [
                        {
                          text: "c)",
                          style: "textGeneral",
                        },
                        {
                          text: `${getLabel( ReporteLang, "materiaC", lenguaje)}\n`,
                          style: "textGeneral",
                          margin: [-5, 0, 0, 2],
                        },
                      ],
                      [
                        {
                          text: "d)",
                          style: "textGeneral",
                        },
                        {
                          text: `${getLabel( ReporteLang, "materiaD", lenguaje)}\n`,
                          style: "textGeneral",
                          margin: [-5, 0, 0, 2],
                        },
                      ],
                      [
                        {
                          text: "e)",
                          style: "textGeneral",
                        },
                        {
                          text: `${getLabel( ReporteLang, "materiaE", lenguaje)}\n`,
                          style: "textGeneral",
                          margin: [-5, 0, 0, 2],
                        },
                      ],
                      [
                        {
                          text: "f)",
                          style: "textGeneral",
                        },
                        {
                          text: `${getLabel( ReporteLang, "materiaF", lenguaje)}\n`,
                          style: "textGeneral",
                          margin: [-5, 0, 0, 2],
                        },
                      ],
                    ],
                  },
                  layout: "noBorders",
                  margin: [0, 0, 0, 8],
                },
                



              ],
            },
            //-------------SEGUNDA COLUMNA
            {
              width: 18,
              text: "",
            },
            //-------------TERCERA COLUMNA

            {
              width: "*",
              lineHeight: 1.15,
              stack: [
                {
                  table: {
                    widths: ["4%", "*"],
                    body: [
                      [
                        {
                          text: "",
                          style: "textGeneral",
                        },
                        {
                          text: `${getLabel( ReporteLang, "entregaB_1", lenguaje)}`,
                          style: "textGeneral",
                          margin: [-5, -3, 0, 0],
                        },
                      ],
                      [
                        {
                          text: "c)",
                          style: "textGeneral",
                        },
                        {
                          text: `${getLabel( ReporteLang, "entregaC", lenguaje)}\n`,
                          style: "textGeneral",
                          margin: [-5, -3, 0, 0],
                        },
                      ],
                    ],
                  },
                  layout: "noBorders",
                  margin: [0, 0, 0, 8],
                },
                {
                  text: `6. ${getLabel(ReporteLang, "defectos", lenguaje)}\n`,
                  style: "textGeneralBold",
                  margin: [0, 5, 0, 0],
                },
                {
                  table: {
                    widths: ["4%", "*"],
                    body: [
                      [
                        {
                          text: "a)",
                          style: "textGeneral",
                        },
                        {
                          text: `${getLabel( ReporteLang, "defectosA", lenguaje)}`,
                          style: "textGeneral",
                          margin: [-5, 0, 0, 0],
                        },
                      ],
                      [
                        {
                          text: "b)",
                          style: "textGeneral",
                        },
                        {
                          text: `${getLabel( ReporteLang, "defectosB", lenguaje)}`,
                          style: "textGeneral",
                          margin: [-5, 0, 0, 0],
                        },
                      ],
                      [
                        {
                          text: "c)",
                          style: "textGeneral",
                        },
                        {
                          text: `${getLabel( ReporteLang, "defectosC", lenguaje)}`,
                          style: "textGeneral",
                          margin: [-5, 0, 0, 0],
                        },
                      ],
                      [
                        {
                          text: "d)",
                          style: "textGeneral",
                        },
                        {
                          text: `${getLabel( ReporteLang, "defectosD", lenguaje)}`,
                          style: "textGeneral",
                          margin: [-5, 0, 0, 0],
                        },
                      ],
                    ],
                  },
                  layout: "noBorders",
                  margin: [0, 0, 0, 8],
                },

                {
                  text: `7. ${getLabel(ReporteLang, "condiciones", lenguaje)}\n`,
                  style: "textGeneralBold",
                  margin: [0, 5, 0, 0],
                },
                {
                  table: {
                    widths: ["4%", "*"],
                    body: [
                      [
                        {
                          text: "a)",
                          style: "textGeneral",
                        },
                        {
                          text: `${getLabel( ReporteLang, "condicionesA", lenguaje)}` + `${CreditLimitLetras}` + `(USD ${selected?.CreditLimit})` + 
                                `${getLabel( ReporteLang, "condicionesA_1", lenguaje)}` + `${TerminoLetras}` + `(${selected?.TermValue})` + 
                                `${getLabel( ReporteLang, "condicionesA_2", lenguaje)}`,
                          style: "textGeneral",
                          margin: [-5, 0, 0, 0],
                        },
                      ],
                      [
                        {
                          text: "b)",
                          style: "textGeneral",
                        },
                        {
                          text: `${getLabel( ReporteLang, "condicionesB", lenguaje)}`,
                          style: "textGeneral",
                          margin: [-5, 0, 0, 0],
                        },
                      ],
                      [
                        {
                          text: "c)",
                          style: "textGeneral",
                        },
                        {
                          text: `${getLabel( ReporteLang, "condicionesC", lenguaje)}`,
                          style: "textGeneral",
                          margin: [-5, 0, 0, 0],
                        },
                      ],
                    ],
                  },
                  layout: "noBorders",
                  margin: [0, 0, 0, 8],
                },

                {
                  text: `8. ${getLabel(ReporteLang, "transferencia", lenguaje)}\n`,
                  style: "textGeneralBold",
                  margin: [0, 5, 0, 0],
                },
                {
                  text: `${getLabel(ReporteLang, "transferenciaText", lenguaje)}\n\n`,
                  style: "textGeneral",
                  margin: [0, 5, 0, 0],
                },

                {
                  text: `9. ${getLabel(ReporteLang, "resolucion", lenguaje)}\n`,
                  style: "textGeneralBold",
                  margin: [0, 5, 0, 0],
                },
                {
                  text: `${getLabel(ReporteLang, "resolucionText", lenguaje)}\n`,
                  style: "textGeneral",
                  margin: [0, 5, 0, 0],
                },

                //--------------------------------------------------------------HOJA 2----------------------------------------------------------------
                {
                  table: {
                    widths: ["4%", "*"],
                    body: [
                      [
                        {
                          text: " ",
                          style: "textGeneral",
                        },
                        {
                          text: `${getLabel( ReporteLang, "materiaF1", lenguaje)}\n\n`,
                          style: "textGeneral",
                          margin: [-5, 50, 0, 2],
                        },
                      ],
                    ],
                  },
                  layout: "noBorders",
                  margin: [0, 0, 0, 8],
                },

                {
                  text: `12. ${getLabel(ReporteLang, "vigencia", lenguaje)}\n`,
                  style: "textGeneralBold",
                  margin: [0, 5, 0, 0],
                },
                {
                  text: `${getLabel(ReporteLang, "vigenciaText", lenguaje)}` + `${duracionLetras}` + `(${selected?.Duracion}) ` + 
                  `${getLabel(ReporteLang, "vigenciaText1", lenguaje)}\n\n`,
                  style: "textGeneral",
                },

                {
                  text: `13. ${getLabel(ReporteLang, "disposiciones", lenguaje)}\n`,
                  style: "textGeneralBold",
                  margin: [0, 5, 0, 0],
                },
                {
                  table: {
                    widths: ["4%", "*"],
                    body: [
                      [
                        {
                          text: "a)",
                          style: "textGeneral",
                        },
                        {
                          text: `${getLabel( ReporteLang, "disposicionesA", lenguaje)}\n`,
                          style: "textGeneral",
                          margin: [-5, 0, 0, 2],
                        },
                      ],
                      [
                        {
                          text: "b)",
                          style: "textGeneral",
                        },
                        {
                          text: `${getLabel( ReporteLang, "disposicionesB", lenguaje)}\n`,
                          style: "textGeneral",
                          margin: [-5, 0, 0, 2],
                        },
                      ],
                      [
                        {
                          text: "c)",
                          style: "textGeneral",
                        },
                        {
                          text: `${getLabel( ReporteLang, "disposicionesC", lenguaje)}\n`,
                          style: "textGeneral",
                          margin: [-5, 0, 0, 2],
                        },
                      ],
                    ],
                  },
                  layout: "noBorders",
                  margin: [0, 0, 0, 8],
                },

                {
                  text: `${getLabel(ReporteLang, "fecha", lenguaje)}: ` + `${fechaFormateada}`,
                  style: "textGeneral",
                  margin: [0, 15, 0, 0],
                },

                {
                  text: `${getLabel(ReporteLang, "comprador", lenguaje)}`,
                  style: "textGeneralBold",
                  margin: [0, 60, 0, 0],
                },
                {
                  text: `${selected?.NombreRepresentanteLegal || ''}`,
                  style: "textGeneral",
                  margin: [0, 0, 0, 0],
                },
                {
                  text: `${selected?.CustomerName || ''}`,
                  style: "textGeneral",
                  margin: [0, 2, 0, 0],
                },
                {
                  text: `${getLabel(ReporteLang, "direccion", lenguaje)}: ` + `${selected?.Address}`,
                  style: "textGeneral",
                  margin: [0, 2, 0, 0],
                },

                {
                  text: `${getLabel(ReporteLang, "vendedor", lenguaje)}`,
                  style: "textGeneralBold",
                  margin: [0, 70, 0, 0],
                },
                {
                  text: `Roberto Bueso Araujo`,
                  style: "textGeneral",
                  margin: [0, 0, 0, 0],
                },
                {
                  text: `Pride Performance Fabrics, S. A. de C. V.`,
                  style: "textGeneral",
                  margin: [0, 0, 0, 0],
                },
                {
                  text: `${getLabel(ReporteLang, "direccion", lenguaje)}: Km. 19.5 Carretera a Occidente, La Acequia, Quimistán, Santa Bárbara, Honduras, C.A.`,
                  style: "textGeneral",
                  margin: [0, 2, 0, 0],
                },

              ]
            },
          ],

        },
      ],

      // ESTILOS
      styles: {
        tituloHeader: {
          fontSize: 10,
          bold: true,
          alignment: "right",
        },
        titulo: {
          fontSize: 10,
          // bold: true,
          alignment: "right",
        },
        textGeneral: {
          fontSize: 9.5,
          alignment: "justify",
        },
        textGeneralBold: {
          fontSize: 9.5,
          bold: true,
          alignment: "justify",
        },

        titulo3: {
          fontSize: 8.5,
          semmibold: true,
          alignment: "justify",
        },
        header: {
          fontSize: 9,
          alignment: "justify",
          bold: true,
        },
        infoGeneral: {
          fontSize: 8.5,
          alignment: "justify",
        },
        headerTable: {
          fontSize: 7.5,
          alignment: "center",
          bold: true,
        },
        headerTable1: {
          fontSize: 8,
          // alignment: "center",
          bold: true,
        },
        textBody: {
          fontSize: 8,
          alignment: "center",
        },
        textBody1: {
          fontSize: 8,
          alignment: "justify",
        },
        textBody2: {
          fontSize: 8,
          alignment: "right",
        },
        textTotales: {
          bold: true,
          fontSize: 10,
          alignment: "right",
        },
        textTotales2: {
          // bold: true,
          fontSize: 10,
          alignment: "right",
        },
        footer: {
          fontSize: 7.5,
          alignment: "left",
          margin: [30, 0, 5, 0],
        },
        firmas: {
          fontSize: 8,
          bold: true,
          alignment: "center",
          lineHeight: 1,
        },
        //CONTENIDO
        title: {
          fontSize: 13,
          bold: true,
          alignment: "center",
        },
        text1: {
          fontSize: 9,
          alignment: "justify",
        },
        text1_1: {
          fontSize: 9,
          alignment: "justify",
          bold: true,
        },
        text2: {
          fontSize: 9,
          bold: true,
          alignment: "justify",
        },
        textBlue: {
          fontSize: 9,
          bold: true,
          alignment: "justify",
          color: "blue",
        },
        textRed: {
          fontSize: 9,
          bold: true,
          alignment: "justify",
          color: "red",
        },
      },
    };

    const doc = pdfMake.createPdf(docDefinition);

    await new Promise((resolve) => {
      doc.getDataUrl((url) => {
        reporte.push(url);
        resolve();
      });
    });

    setPdf(reporte);
  };

  useEffect(() => {
    getInfo();
  }, []);

  return (
    <div>
      <Dialog
        visible={showReporte}
        modal
        onHide={() => setShowReporte(false)}
        style={{ width: "63vw", height: "85vh" }}
        closeOnEscape={false}
      >
        <div id="Dialog">
          {!loading && pdf && (
            <iframe
              src={pdf}
              style={{
                width: "60vw",
                height: "75vh",
                border: "1px solid #ccc",
              }}
              id="foo"
              title="Reporte QR PDF"
            />
          )}
        </div>
      </Dialog>
    </div>
  );
};

export default ConvenioDoc;
